import { render, staticRenderFns } from "./MatchList.vue?vue&type=template&id=00540886&scoped=true"
import script from "./MatchList.vue?vue&type=script&lang=js"
export * from "./MatchList.vue?vue&type=script&lang=js"
import style0 from "./MatchList.vue?vue&type=style&index=0&id=00540886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00540886",
  null
  
)

export default component.exports